<div>
  <div class="modal-header modalHeaderBlack">
    <h6 class="modal-title">Checkout Confirmation</h6>
    <mat-icon matTooltip="close" (click)="onClose()">clear</mat-icon>
  </div>

  <br />
  <span class="text"> Do you want to check out the patient? </span>
  <br /><br />
  <button
  matTooltip="No"
    class="btn-action"
    style="margin-left: 85px; background-color: #f02b2b"
    (click)="onClose()"
  >
    No
  </button>
  <button
  matTooltip="Yes"
    class="btn-action"
    style="background-color: #0c8c72"
    (click)="confirmCheckout()"
  >
    Yes
  </button>
  <br />
</div>
